import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "Components/Common/Dialog/DialogComponents";
import "../../../Sass/Common.scss";
import PatientsCreateAndEdit from "Components/Patients/PatientsCreateAndEdit";
import { ReactComponent as NoteTextIcon } from "Assets/Icons/PharmsmartIcon/NoteTextcon.svg";
import { ReactComponent as PatientDetails } from "Assets/Icons/PharmsmartIcon/PatientDetails.svg";

// import { ReactComponent as ModalCloseIcon } from "Assets/Icons/ModalCloseIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import clsx from "clsx";
import { IconButton, Box } from "@mui/material";
const useStyle = makeStyles((theme) => ({
  rsUpdateDialog: {
    "&>div": {
      "&>div": {
        background: "#efefef",
        maxHeight: "calc(100% - 20px)",
        borderRadius: "10px !important",
        "&>div:nth-child(1)": {
          "&>h2": {
            "&>p": {
              paddingBottom: "10px",
            },
          },
          "&>div:nth-child(1)": {
            paddingTop: "10px",
            "&>svg": {
              height: "50px",
              width: "50px",
            },
          },
        },
      },
    },
    "& .MuiPaper-root.MuiPaper-elevation": {
      top: "-15px !important",
      "&>div": {
        paddingTop: "0px",
        paddingBottom: "0px",
      },
    },
  },
  rsDailogTitle: {
    background: "red !important",
  },
}));
// Add RX Patient Create
const PatientCreateDialog = (props) => {
  const { callBackOnSubmit, callBackOnCancel, open, setOpen } = props;
  const classes = useStyle();

  const handleClose = () => {
    setOpen(false);
  };

  const callBackOfPatientFormSubmit = (responseData) => {
    handleClose();
    if (typeof callBackOnSubmit === "function") {
      callBackOnSubmit(responseData);
    }
  };

  const callBackOfPatientFormCancel = () => {
    handleClose();
    if (typeof callBackOnCancel === "function") {
      callBackOnCancel();
    }
  };

  return (
    <>
      <Dialog
        // className="RSxs_modal"
        open={open}
        maxWidth={"lg"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("RSxs_modal", classes.rsUpdateDialog)}
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          className={classes.rsDailogTitle}
          title="Create New Patient"
          icon={PatientDetails}
        />
        <Box>
          <DialogContent className="DropdownDialogContent">
            <PatientsCreateAndEdit
              _pageAccessMode="create"
              callBackOnSubmit={callBackOfPatientFormSubmit}
              callBackOnCancel={callBackOfPatientFormCancel}
              dialog={true}
            />
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

export default PatientCreateDialog;
